import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16, IcoPlusSmall16 } from '@onefootprint/icons';
import LinkButton from '../../../../../link-button';
import Input from '../../../../../text-input';
type EnumEditorProps = {
  values: string[];
  onChange: (values: string[]) => void;
  isDisabled?: boolean;
};
const EnumEditor = t0 => {
  const $ = _c(24);
  const {
    values,
    onChange,
    isDisabled: t1
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onChange || $[1] !== values) {
    t2 = (index, value) => {
      const newValues = [...values];
      newValues[index] = value;
      onChange(newValues);
    };
    $[0] = onChange;
    $[1] = values;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleValueChange = t2;
  let t3;
  if ($[3] !== onChange || $[4] !== values) {
    t3 = () => {
      onChange([...values, ""]);
    };
    $[3] = onChange;
    $[4] = values;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleAddValue = t3;
  let t4;
  if ($[6] !== onChange || $[7] !== values) {
    t4 = index_0 => {
      onChange(values.filter((_, i) => i !== index_0));
    };
    $[6] = onChange;
    $[7] = values;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleRemoveValue = t4;
  let t5;
  if ($[9] !== handleRemoveValue || $[10] !== handleValueChange || $[11] !== isDisabled || $[12] !== values) {
    let t6;
    if ($[14] !== handleRemoveValue || $[15] !== handleValueChange || $[16] !== isDisabled) {
      t6 = (value_0, index_1) => <div key={index_1} className="inline-flex items-center gap-1"><Input value={value_0} onChange={e => handleValueChange(index_1, e.target.value)} placeholder="value" disabled={isDisabled} size="compact" suffixComponent={<button type="button" onClick={() => handleRemoveValue(index_1)} className="cursor-pointer"><IcoCloseSmall16 color="tertiary" /></button>} /></div>;
      $[14] = handleRemoveValue;
      $[15] = handleValueChange;
      $[16] = isDisabled;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t5 = values.map(t6);
    $[9] = handleRemoveValue;
    $[10] = handleValueChange;
    $[11] = isDisabled;
    $[12] = values;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[18] !== handleAddValue || $[19] !== isDisabled) {
    t6 = <LinkButton onClick={handleAddValue} iconComponent={IcoPlusSmall16} iconPosition="left" disabled={isDisabled}>Add</LinkButton>;
    $[18] = handleAddValue;
    $[19] = isDisabled;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t5 || $[22] !== t6) {
    t7 = <div className="flex flex-wrap items-center gap-2 ml-5">{t5}{t6}</div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default EnumEditor;